import React from 'react';
import ThankYou from '../templates/thank-you';

function ThankYouPage() {
  return <ThankYou />;
}

export default ThankYouPage;
